import { useState, useCallback } from "react";

interface ConfirmParams {
  title?: string;
  description?: string;
}

export function useConfirm() {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("Are you sure?");
  const [description, setDescription] = useState(
    "This action cannot be undone.",
  );
  const [promise, setPromise] = useState<{
    resolve: (value: boolean) => void;
    reject: () => void;
  }>();

  const confirm = useCallback((params?: ConfirmParams) => {
    const {
      title = "Are you sure?",
      description = "This action cannot be undone.",
    } = params || {};

    setIsOpen(true);
    setTitle(title);
    setDescription(description);
    return new Promise<boolean>((resolve, reject) => {
      setPromise({ resolve, reject });
    });
  }, []);

  const handleConfirm = () => {
    setIsOpen(false);
    promise?.resolve(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
    promise?.resolve(false);
  };

  return { isOpen, title, description, confirm, handleConfirm, handleCancel };
}
